<template>
  <v-dialog fullscreen v-model="dialog" transition="dialog-bottom-transition">
    <v-card>

      <v-toolbar fixed dark color="primary">
        <v-btn icon @click="hide">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>{{defaultCoupon ? 'Ver' : 'Crear'}} Cupon</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="showDelete" depressed v-if="defaultCoupon && !defaultCoupon.redeemed">
          <v-icon size="18" class="mr-1">fa-trash</v-icon>
          Eliminar
        </v-btn>
        <v-btn v-if="!defaultCoupon" :disabled="!valid" :loading="loading" @click="saveCoupon" color="primary" depressed>
          <v-icon class="mr-2">fa-save</v-icon>
          Guardar
        </v-btn>
      </v-toolbar>

      <v-card-text v-if="defaultCoupon">
        <v-alert color="primary" type="info" dark :value="true">
          Los cupones no pueden ser editados
        </v-alert>
      </v-card-text>

      <v-card-text>
        <v-form v-model="valid" ref="form">
          <v-container>
            <v-layout wrap justify-center pa-4 mt-4>
              <v-flex xs12 md8 xl6 text-xs-center>
                <v-layout wrap mt-4>

                  <v-flex xs12 px-1 py-0>
                    <v-text-field
                        :readonly="!!defaultCoupon"
                        box
                        :rules="nameRules"
                        v-model="name"
                        label="Nombre del Cupon"
                        placeholder="Ej. Cupón de Descuento"
                    />
                  </v-flex>

                  <v-flex xs12 px-1 py-0>
                    <v-radio-group :readonly="!!defaultCoupon" v-model="discountType" row label="Tipo de descuento">
                      <v-radio label="Porcentaje" value="PERCENT"></v-radio>
                      <v-radio label="CLP" value="CLP"></v-radio>
                      <v-radio label="UF" value="UF"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex xs12 md6 px-1 py-0>
                    <v-text-field
                        :readonly="!!defaultCoupon"
                        :rules="amountRules"
                        :prefix="amountPrefix"
                        prepend-inner-icon="fa-dollar-sign"
                        label="Descuento"
                        type="number"
                        v-model="amount"
                        box
                      />
                  </v-flex>

                  <v-flex xs12 md6 px-1 py-0>
                    <v-text-field
                        :readonly="!!defaultCoupon"
                        :rules="timesRules"
                        prepend-inner-icon="fa-calendar-alt"
                        label="Duracion (Meses)"
                        hint="Meses en los"
                        type="number"
                        v-model="times"
                        box
                      />
                  </v-flex>

                  <v-flex xs12 px-1 py-0>
                    <provider-picker
                        :readonly="!!defaultCoupon"
                        ref="providerPicker"
                        box
                        label="Solo disponible para"
                        @change="provider = $event" />
                  </v-flex>

                </v-layout>
              </v-flex>

            </v-layout>

          </v-container>
        </v-form>
      </v-card-text>

    </v-card>
    <kimsa-confirm
        ref="deleteDialog"
        title="Eliminar Cupon"
        content="¿Confirmas que deseas eliminar este cupon?"
        :loading="deleting"
        @confirm="deleteCoupon"
      />
  </v-dialog>
</template>

<script>
import {ApiUtils} from "@/utils/ApiUtils";
import ProviderPicker from "@/components/admin/ProviderPicker";
import KimsaConfirm from "../../common/KimsaConfirm";

export default {
  name: "PlanEditor",
  components: {KimsaConfirm, ProviderPicker},
  data(vm){
    return {

      defaultCoupon: null,
      discountType: 'PERCENT',

      loading: false,
      deleting: false,
      dialog: false,
      valid: false,

      name: 'Cupón de Descuento',
      recommended: false,
      description: '',
      amount: 0,
      max_specialists: 1,
      provider: null,
      times: 3,
      target: 'all',
      features: [],

      targetOptions: [
        {value: 'all', text: 'Cualquier paciente', disabled: vm.max_specialists > 1},
        {value: 'individual', text: 'Consultas Individuales', disabled: vm.max_specialists > 1},
        {value: 'institution', text: 'Centros'}
      ],

      featureOptions: [
        {value: 'vc', text: 'Videoatención'}
      ],

      nameRules: [
          v => !!v && v.length > 4 || 'Campo requerido (min: 5 caracteres)'
      ],
      descriptionRules: [
          v => (!v || (!!v && v.length >= 10)) || 'Min. 10 caracteres'
      ],
      maxSpecialistsRules: [
          v => (Number.isInteger(Number(v)) && v > 0 && v <= 500) || 'Valor inválido (min: 1, max: 500)'
      ],
      timesRules: [
          v => (Number.isInteger(Number(v)) && v > 0 && v <= 12) || 'Valor inválido (min: 1, max: 12)'
      ]
    }
  },
  methods:{
    showDelete(){
      const vm = this
      vm.$refs.deleteDialog.show()
    },
    async saveCoupon(){
      const vm = this

      let payload = {
        name: vm.name,
        times: vm.times,
      }

      if(vm.discountType == 'PERCENT'){
        payload.percent_off = vm.amount
      }else{
        payload.amount = vm.amount
        payload.currency = vm.discountType
      }

      if(vm.provider){
        payload.service_provider_id = vm.provider.value
      }

      vm.loading = true
      const response = vm.defaultCoupon ?
          await ApiUtils.makePatch(`subscriptions/coupons/${vm.defaultCoupon.id}`, null, payload)
          : await ApiUtils.makePost('subscriptions/coupon', payload)
      vm.loading = false

      if(!response.ok){
        const json = await response.json()
        const message = json.message || 'Ocurrió un error creando el cupon'
        return vm.toast(message, 'error')
      }

      vm.toast('¡Cupon guardado!')
      vm.$emit('saved')
      vm.hide()
      vm.reset()

    },
    async deleteCoupon(){
      const vm = this

      if(!vm.defaultCoupon){
        return
      }

      if(vm.deleting) return

      vm.deleting = true
      const response = await ApiUtils.makeDelete(`subscriptions/coupons/${vm.defaultCoupon.id}`)
      vm.deleting = false

      if(!response.ok){
        const json = await response.json()
        const message = json.message || 'Ocurrió un error eliminando el cupon'
        return vm.toast(message, 'error')
      }

      vm.toast('¡Cupon eliminado!', 'error')
      vm.$emit('deleted')
      vm.$refs.deleteDialog.hide()
      vm.hide()
      vm.reset()

    },
    reset(){
      const vm = this
      vm.defaultCoupon = null
      vm.name = ''
      vm.amount = 0
      vm.couponType = 'PERCENT'
      vm.provider = null
      vm.times = 6
      vm.$refs.providerPicker.model = null
    },

    setDefaults(){

      const vm = this
      let coupon = vm.defaultCoupon
      if(!coupon) return vm.reset()

      vm.name = coupon.name

      if(coupon.percent_off){
        vm.amount = coupon.percent_off
        vm.discountType = 'PERCENT'
      }else{
        vm.discountType = coupon.currency
        vm.amount = coupon.amount
      }

      vm.provider = coupon.service_provider || null
      vm.times = coupon.times

      vm.$refs.providerPicker.model = coupon.service_provider ? {
        text: coupon.service_provider.name,
        value: coupon.service_provider.id
      } : null
    },

    show(couponToEdit = null){
      const vm = this
      vm.defaultCoupon = couponToEdit
      vm.$nextTick(function(){
        vm.dialog = true
      })

    },
    hide(){
      const vm = this
      vm.dialog = false
    }
  },
  computed:{
    amountRules(){
      const vm = this
      let min,max;
      switch(vm.discountType){
        case 'PERCENT':
          max = 100
          min = 0.1
          break
        case 'UF':
          max = 2
          min = 0.1
          break
        default:
          max = 20000
          min = 1000
          break
      }

      return [
        v => v >= min && v <= max || `Valor inválido (min: ${min}, max: ${max})`
      ]
    },
    amountPrefix(){
      const vm = this
      if(vm.discountType === 'PERCENT'){
        return '%'
      }

      return vm.discountType

    },
  },
  watch:{
    discountType(){
      const vm = this
      vm.$refs.form.resetValidation()
      vm.$refs.form.validate()
    },
    defaultCoupon(val){
      if(val) this.setDefaults()
    }
  }
}
</script>

<style scoped>

</style>